<template>
    <div class="dashboard-income-table-header">
        <div
            class="dashboard-income-table-header__column"
            v-for="column in getColumns"
            :key="column.id"
            :class="column.class"
        >
            <p class="dashboard-income-table-header__label">
                {{ column.label }}
            </p>

            <p
                class="dashboard-income-table-header__label dashboard-income-table-header__label--small"
                v-if="column.labelSmall"
            >
                {{ column.labelSmall }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "DashboardIncomeTableHeader",
    computed: {
        getColumns() {
            return [
                {
                    id: 0,
                    label: this.$t('wallet.date'),
                    labelSmall: `${this.$t('wallet.date')} / ${this.$t('dashboard.hashrate24h')}`,
                    class: "dashboard-income-table-header__column--date",
                },
                {
                    id: 1,
                    label: this.$t('dashboard.hashrate24h'),
                    labelSmall: `${this.$t('dashboard.income')} / ${this.$t('dashboard.bonus')}`,
                    class: "dashboard-income-table-header__column--hashrate",
                },
                {
                    id: 2,
                    label: this.$t('dashboard.incomeBTC'),
                    class: "dashboard-income-table-header__column--income",
                },
                {
                    id: 3,
                    label: this.$t('dashboard.bonusBTC'),
                    class: "dashboard-income-table-header__column--bonus",
                },
                {
                    id: 4,
                    label: this.$t('dashboard.rateSatTH'),
                    class: "dashboard-income-table-header__column--rate",
                },
                {
                    id: 5,
                    label: this.$t('dashboard.incomeRUB'),
                    class: "dashboard-income-table-header__column--rub",
                },
            ];
        },
    },
};
</script>

<style lang="scss">
.dashboard-income-table-header {
    background: $bg-gray;
    border-radius: 10px;
    display: grid;
    grid-template-columns: 230px 1fr 1fr 1fr 1fr 1fr;
    padding: 10px 0;

    .dashboard-income-table-header__column {
        display: flex;
        align-items: center;
        padding: 0 30px;
    }

    .dashboard-income-table-header__label {
        @include golos-semi-bold;
        font-size: 12px;
        line-height: 17px;
        text-transform: uppercase;
        color: $txt-main;
        text-align: left;
    }

    .dashboard-income-table-header__label--small {
        display: none;
    }
}

// @media screen and (max-width: 1440px) {
//     .dashboard-income-table-header {
//         grid-template-columns: 230px 1fr 1fr 1fr;

//         .dashboard-income-table-header__column--rate,
//         .dashboard-income-table-header__column--uptime {
//             display: none;
//         }
//     }
// }

@media screen and (max-width: 1024px) {
    .dashboard-income-table-header {
        grid-template-columns: 230px 1fr 1fr;

        .dashboard-income-table-header__column--bonus,
        .dashboard-income-table-header__column--rate,
        .dashboard-income-table-header__column--rub {
            display: none;
        }
    }
}

@media screen and (max-width: 768px) {
    .dashboard-income-table-header {
        grid-template-columns: 1fr 1fr 55px;
        border-radius: 0;
        padding: 13px 0;

        .dashboard-income-table-header__column {
            padding: 0 12px;
        }

        .dashboard-income-table-header__label {
            font-size: 10px;
            line-height: 16px;
            display: none;
        }

        .dashboard-income-table-header__label--small {
            display: inline-block;
        }

        .dashboard-income-table-header__column--hashrate {
            justify-content: flex-end;
        }
    }
}
</style>
